<template>
  <section class="three-bet-cbet-explorer-table well">
    <table class="table">
      <thead>
        <tr>
          <th>Continue vs. 3bet</th>
          <td
            data-title="This is based on what you have selected in the hand matrixes below."
            data-toggle="tooltip"
            data-placement="bottom"
            data-container="body"
          >
            <em>{{ selectedContinueVs3betPercentage }}%</em>
          </td>
          <td>0%</td>
          <td>20%</td>
          <td>40%</td>
          <td>60%</td>
          <td>80%</td>
          <td>100%</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>EV</th>
          <td
            data-title="This is based on what you have selected in the hand matrixes below."
            data-toggle="tooltip"
            data-placement="bottom"
            data-container="body"
            v-bind:class="getColorClass(evForSelected)"
          >
            <em>{{ getEVDisplayText(evForSelected) }}</em>
          </td>
          <td v-bind:class="getColorClass(evForZeroPercent)">{{ getEVDisplayText(evForZeroPercent) }}</td>
          <td v-bind:class="getColorClass(evForTwentyPercent)">{{ getEVDisplayText(evForTwentyPercent) }}</td>
          <td v-bind:class="getColorClass(evForFourtyPercent)">{{ getEVDisplayText(evForFourtyPercent) }}</td>
          <td v-bind:class="getColorClass(evForSixtyPercent)">{{ getEVDisplayText(evForSixtyPercent) }}</td>
          <td v-bind:class="getColorClass(evForEightyPercent)">{{ getEVDisplayText(evForEightyPercent) }}</td>
          <td v-bind:class="getColorClass(evForOneHundredPercent)">{{ getEVDisplayText(evForOneHundredPercent) }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {
  name: 'three-bet-cbet-explorer-table',
  props: [
    'selectedContinueVs3betPercentage',
    'evForSelected',
    'evForZeroPercent',
    'evForTwentyPercent',
    'evForFourtyPercent',
    'evForSixtyPercent',
    'evForEightyPercent',
    'evForOneHundredPercent'
  ],
  mounted: function () {
    if (process.env.NODE_ENV !== 'testing') {
      $(this.$el).find('[data-toggle="tooltip"]').tooltip();
    }
  },
  methods: {
    getEVDisplayText: function (ev) {
      if (ev === null || isNaN(ev)) {
        return 'n/a';
      }

      return `${ev}bb`;
    },
    getColorClass: function (ev) {
      if (ev === null || isNaN(ev)) {
        return;
      }

      if (ev >= 5.5) {
        return 'green-95-100';
      } else if (ev >= 5) {
        return 'green-90-95';
      } else if (ev >= 4.5) {
        return 'green-85-90';
      } else if (ev >= 3) {
        return 'green-80-85';
      } else if (ev >= 2.5) {
        return 'green-75-80';
      } else if (ev >= 2) {
        return 'green-70-75';
      } else if (ev >= 1.5) {
        return 'green-65-70';
      } else if (ev >= 1) {
        return 'green-60-65';
      } else if (ev >= 0.5) {
        return 'green-55-60';
      } else if (ev > 0) {
        return 'green-50-55';
      } else if (ev === 0) {
        return 'gray-50';
      } else if (ev >= -0.5) {
        return 'red-45-50';
      } else if (ev >= -1) {
        return 'red-40-45';
      } else if (ev >= -1.5) {
        return 'red-35-40';
      } else if (ev >= -2) {
        return 'red-30-35';
      } else if (ev >= -2.5) {
        return 'red-25-30';
      } else if (ev >= -3) {
        return 'red-20-25';
      } else if (ev >= -3.5) {
        return 'red-15-20';
      } else if (ev >= -4) {
        return 'red-10-15';
      } else if (ev >= -4.5) {
        return 'red-5-10';
      } else if (ev < -4.5) {
        return 'red-0-5';
      } else {
        console.log(ev);
        throw new Error('Invalid value for ev');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .three-bet-cbet-explorer-table {
    padding: 5px;

    thead td {
      vertical-align: bottom;
    }

    .table {
      margin-bottom: 0;
    }

    [data-toggle="tooltip"] {
      cursor: help;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/three-bet-cbet-explorer/three-bet-cbet-explorer-table.vue